import { FormControlLabel, Typography } from '@mui/material';

import React from 'react';
import { logEventAnalytic } from 'src/utilities/logAnalytics';
import useTranslation from 'next-translate/useTranslation';
import { StyledSwitch } from './BooleanFilter.styles';
import { BooleanFilterProps } from './BooleanFilter.types';

export const BooleanFilter = (props: BooleanFilterProps) => {
  const { filter, selectedOptions, handleSelectedChange } = props;
  const { t } = useTranslation('search');

  const label = t(`filterLabel.${filter.filterName.toLowerCase()}`);

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    isChecked: boolean
  ) => {
    const {
      target: { value },
    } = event;

    logEventAnalytic({
      category: 'Filters',
      action: 'Filter clicked on search page - microsite',
      label: `${value} - ${label}`,
    });
    handleSelectedChange(isChecked ? ['true'] : []);
  };

  return (
    <FormControlLabel
      control={
        <StyledSwitch
          checked={selectedOptions.length > 0}
          onChange={handleChange}
        />
      }
      label={<Typography fontWeight={500}>{label}</Typography>}
    />
  );
};
